import {
  getDiscountLabel,
  getReservationModeLabel,
  getSpecialType,
  hasSingleReservationMode,
} from '@iheartjane/menu';
import { Box, Flex, Image, Typography } from '@iheartjane/reefer';
import type { Breadcrumb } from '@iheartjane/types';

/* eslint-disable-next-line no-restricted-imports */
import type { Store, StoreSpecial } from '@jane/shared/models';
import type { StoreSpecial as zStoreSpecial } from '@jane/shared/types';

import { JumboDiscountBadge } from '../jumboDiscountBadge/jumboDiscountBadge';
import { StyledFlex, StyledLink } from './specialCard.styles';

export interface SpecialCardProps {
  breadcrumbs?: Breadcrumb[];
  onClick?: () => void;
  special: StoreSpecial | zStoreSpecial;
  store: Store;
  to?: string;
}

export const SpecialCard = ({
  breadcrumbs,
  to,
  onClick,
  special,
  store,
}: SpecialCardProps) => {
  const reservationMode = hasSingleReservationMode(special?.reservation_modes);
  const specialAvailability =
    reservationMode &&
    getReservationModeLabel(reservationMode, store?.reservation_mode_labels);

  return (
    <StyledLink
      to={to}
      {...(breadcrumbs && { state: { breadcrumbs } })}
      onClick={onClick}
      ariaLabel={special.title}
      variant="minimal"
      data-testid="special-card"
    >
      <StyledFlex
        flexDirection="column"
        width="100%"
        height="100%"
        border="transparent-black-ten"
        borderRadius="sm"
        overflow="hidden"
      >
        {special.photo?.urls?.original ? (
          <Image
            height="160px"
            width="100%"
            altText={special.title}
            src={special.photo?.urls?.original}
            sizes="card-lg"
            responsive
          />
        ) : (
          <Flex
            height="160px"
            width="100%"
            alignItems="center"
            justifyContent="center"
          >
            <JumboDiscountBadge color="info" textColor="text-info">
              {special.custom_badge
                ? special.custom_badge
                : getDiscountLabel({
                    discountAmount: special.discount_amount,
                    discountType: special.discount_type,
                    specialType: special.special_type,
                    storeComplianceLanguageSettings:
                      store?.store_compliance_language_settings,
                  })}
            </JumboDiscountBadge>
          </Flex>
        )}
        <Box px={24} py={16} width="100%">
          <Flex justifyContent="space-between">
            <Typography color="info" variant="mini-bold">
              {getSpecialType(
                special.special_type,
                store?.store_compliance_language_settings
              )}
            </Typography>
            {specialAvailability && (
              <Typography variant="mini" color="text-light">
                {specialAvailability} only
              </Typography>
            )}
          </Flex>
          <Typography variant="body-bold" maxLines={2}>
            {special.title}
          </Typography>
        </Box>
      </StyledFlex>
    </StyledLink>
  );
};
